// @flow

import React from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { AsyncProductsGrid } from 'Components/widgets/product/AsyncProductsGrid';
import { grid } from 'Components/widgets/product/Product.utils';

import {
  fetchProducts,
  type ProductsGridDescriptorProps,
} from 'Client/cms/toolkit/products-grid/productsGrid.resolver';

import { productsMapper, asyncPropsMapper } from './ProductsGridLine.utils';

type Props = {
  ...$Exact<ProductsGridDescriptorProps>,
  id?: string,
};

export function ProductsGridLine({ id, ...props }: Props) {
  const {
    moreResultsColor,
    moreResultsLabel,
    moreResultsButtonLabel,
    unfoldList,
    productIds = [],
  } = props;
  return (
    <SiteContainer id={id} className="Line">
      <AsyncProductsGrid
        {...props}
        productsMapper={productsMapper}
        asyncPropsMapper={asyncPropsMapper}
        fetchProducts={fetchProducts}
        products={productsMapper(props)}
        grid={grid}
        hasSeeMore={!unfoldList}
        totalNumberToDisplay={productIds.length}
        seeMore={{
          color: moreResultsColor,
          text: moreResultsLabel,
          label: moreResultsButtonLabel,
        }}
      />
    </SiteContainer>
  );
}
